export const HEADER_REGION_CHANGED = 'header:region_changed';
